<template>
    <section id="vue-splash">
        <h1>{{ message }}</h1>
        <button
            class="rsvp-button"
            @click="scrollToForm"
        >
            {{ buttonText }}
        </button>
        <button
            @click="scrollToNextSection"
            class="splash-chevron"
        />
    </section>
</template>

<script>
import zenscroll from 'zenscroll';

export default {
    name: 'splash-view',
    data: () => ({
        message: 'we\'re getting married!',
        buttonText: 'RSVP'
    }),
    methods: {
        scrollToForm: function() {
            const rsvpSection = document.querySelector('#vue-rsvp');

            zenscroll.to(rsvpSection);
        },
        scrollToNextSection: function() {
            const infoSection = document.querySelector('#vue-info');

            zenscroll.to(infoSection);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/splash.vue?535de1a8